<template>
  <div>
    <el-button
      type="primary"
      round
      @click="back"
      size="mini"
      style="margin: 10px 0;margin-left: 10%;"
      >返回</el-button
    >
    <div class="wrapCon">
      <div class="left">
        <h3 style="font-size: 18px !important">预约专家</h3>
        <div class="linkCon">
          <div :class="index == 1 ? 'active' : 'link'" @click="clickLink(1)">
            预约专家流程
          </div>
        </div>
      </div>
      <div class="right">
        <div v-show="index == 1">
          <div class="right_top">
            <div class="title">
              <span class="fontStyle">预约专家流程</span>
            </div>
          </div>
          <div class="middle devide" style="margin-top: 10px">
            <img
              class="qrcode"
              src="~@/assets/images/expert_advisory.jpg"
              alt=""
              width="300px"
            />
            <div class="txt">
              <p>
                （一）使用手机钉钉软件使用手机钉钉扫描群二维码入群，进行在线办理预约。
              </p>
              <p style="text-align: justify">
                （二）预约成功后使用手机钉钉或则电脑版钉钉，参加由税务人员发起的视频会议进行税费业务远程办理。
              </p>
              <p>（三）税务业务办理完成后进行办理流程进行评价。</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {},
  data() {
    return {
      index: 1,
    };
  },
  created() {},
  mounted() {},
  methods: {
    back() {
      this.$parent.topNav = true;
      this.$parent.showFlag = "";
      // this.$router.push({ name: "policyService" });
    },
    clickLink(param) {
      this.index = param;
    },
  },
};
</script>

<style lang='scss' scoped>
$width: 1150px;
.fontStyle {
  font-size: 18px;
  font-weight: 700;
  color: #000;
}
.back {
  cursor: pointer;
  margin: 0 auto;
}
.wrapCon {
  width: $width;
  min-height: 200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .left {
    width: 20%;
    background: #f7f7f7;
    padding: 20px 0;
    // border: 1px solid #ccc;
    h3 {
      text-align: center;
      color: #fff;
      font-size: 22px;
      margin-bottom: 5px;
      margin: 0px auto;
      background-color: #0241FF;
      line-height: 64px;
    }
    .linkCon {
      div {
        cursor: pointer;
        font-size: 18px;
        width: 88%;
        margin: 10px auto;
        text-align: center;
        border: 1px solid #ddd;
        line-height: 52px;
        border-radius: 5px;
        background-color: #fff;
        &:hover {
          color: #fff;
          background-color: #1472FF;
        }
      }
      .active {
        color: #fff;
        background-color: #1472FF;
      }
    }
  }
  .right {
    width: 78%;
    min-height: 400px;
    border-left: 1px solid #ccc;
    padding-left: 20px;
    .right_top {
      width: 100%;
      .title {
        height: 64px;
        border-bottom: 1px solid #ccc;
        span {
          display: inline-block;
          min-width: 110px;
          height: 100%;
          text-align: center;
          line-height: 64px;
          border-bottom: 3px solid #1472FF;
        }
      }
      .content {
        background-color: #ebf6fc;
        padding: 20px;
        margin-top: 10px;
        margin-bottom: 40px;
      }
    }
    .middle {
      background-color: #ebf6fc;
      padding: 20px;
    }
    .devide {
      display: flex;
      align-items: center;
      .txt {
        p {
          padding: 0 10px;
          margin: 15px;
        }
      }
    }
  }
}
</style>
